import { z } from 'zod';

import { IntercomMessageSchema } from './IntercomMessage.schema';
import { LeadAccessSchema, LockedPreviewSchema } from './Lead';

export const IntercomChannelSchema = z.object({
    id: z.string(),
    name: z.string(),
    project: z.string(),
    component: z.string(),
    company: z.string(),
    type: z.enum(['project', 'component', 'company']),
    access: z
        .object({
            company: z.string().nullable(),
        })
        .default({
            company: null,
        }),
    views: z
        .object({
            user: z.string(),
            date: z.date(),
        })
        .array()
        .default([]),
    viewed: z.boolean(),
    createdBy: z.string(),
    createdAt: z.date(),
    team: z.string(),
    leadAccess: LeadAccessSchema.nullish(),
    lockedPreview: LockedPreviewSchema.optional(),
    latestMessage: IntercomMessageSchema.pick({
        content: true,
        createdAt: true,
        createdBy: true,
        createdByCompany: true,
        locked: true,
    }).nullish(),
});

export const IntercomChannelListParamsSchema = z.object({
    page: z.number().optional().default(1),
    depth: z.number().optional().default(0),
    sort: z.string().optional().default('-createdAt'),
    withoutInternal: z.boolean().optional().default(false),
    limit: z.number().optional().default(24),
    company: z.string().optional(),
});
